import { useEffect } from "react";
import { ThemeProvider } from 'styled-components';

import GoldBar from './components/templates/GoldBar'
import Landing from './components/Landing'
import { BrowserRouter } from 'react-router-dom'

const theme = {
  colors: {
    primary: '#FDEB04',
    header1: '#D44430',
    headerText1: '#26C8B5',
    headerHighlight1: '#FCBC15',
    body1: '#E47D1F',
    header2: '#26C8B5',
    headerText2: '#D44430',
    headerHighlight2: '#FCBC15',
    body2: '#00A195',
    header3: '#FCBC15',
    headerText3: '#084A89',
    headerHighlight3: '#26C8B5',
    body3: '#893E77'
  },
  fonts: {
    display: "'Worker', sans-serif",
    text: "'CNNSansDisplay', sans-serif"
  },
  pageWidth: {
    xl: 1200,
    l: 992,
    m: 768,
    s: 576,
    xs: 400
  }
}

function App() {

  const updateCSSViewportHeightValue = () => {
    var vh = (window.innerHeight / 100) + 'px'
    document.querySelector(':root').style.setProperty('--vh', vh)
  }

  useEffect(() => {
    window.addEventListener('resize', updateCSSViewportHeightValue)
    updateCSSViewportHeightValue()
    return () => window.removeEventListener('resize', updateCSSViewportHeightValue)
  })

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <GoldBar content={<Landing></Landing>}></GoldBar>
        </BrowserRouter>
      </ThemeProvider>
    </div >
  );
}

export default App;
